import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "various-arrow-down-selected",
  "use": "various-arrow-down-selected-usage",
  "viewBox": "0 0 14 33",
  "content": "<symbol viewBox=\"0 0 14 33\" xmlns=\"http://www.w3.org/2000/svg\" id=\"various-arrow-down-selected\"><path d=\"M8 2v17h6L7 33 0 19h6V2H0V0h14v2H8z\" fill=\"#e3000f\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol